import React, { useRef, useEffect, useState } from 'react';
import DatePicker2 from '../components/Datepicker'
import VariableProximity from '../components/VariableProx'
import { useNavigate } from "react-router-dom";
import { timeOptions } from '../js/businessHour'
import AlertWindow from '../components/Alert'
import { useDispatch, useSelector } from 'react-redux';
import { updateSearchData, setBookingId } from "../redux/data.js";
import { requestData } from '../js/api.js'

function Home() {
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchData = useSelector((state) => state.data.searchData);
  const [popSelectDate, setPopSelectDate] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')
  const [openAlert, setOpenAlert] = useState(false)
  const [branches, setBranches] = useState([])
  const [loading, setLoading] = useState(true)

  const changeSearchData = (key, val) => {
    dispatch(updateSearchData({ key: key, value: val }));
  }

  const selectDateEvent = (event) => {
    if (event && event === 'check') {
      if (searchData.startDate === '' || searchData.endDate === '') {
        setAlertMessage('Please select the start date and return date')
        setOpenAlert(true)
        return
      }
    }
    setPopSelectDate(!popSelectDate)
  }

  const getDate = (selectedStartDate, selectedEndDate) => {
    dispatch(updateSearchData({ key: 'startDate', value: selectedStartDate }));
    dispatch(updateSearchData({ key: 'endDate', value: selectedEndDate }));
  }

  const findVehicle = () => {
    if (searchData.pickup === '') {
      setAlertMessage('Please select the pickup location')
      setOpenAlert(true)
      return
    }
    if (searchData.startDate === '' || searchData.endDate === '') {
      setAlertMessage('Please select the start date and return date')
      setOpenAlert(true)
      return
    }
    navigate("/booking/select-vehicle")
    dispatch(setBookingId('select-vehicle'));
  }

  const getBranch = async () => {
    setLoading(true)
    try {
      let data = await requestData('GET', 'getbranch');
      setBranches(data)
      let firstAvailable = data.find(item => item.status === 'available');
      dispatch(updateSearchData({ key: 'pickup', value: firstAvailable.id }));

    } catch (error) {
      console.error('Error:', error.message);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getBranch()
  }, [])    // eslint-disable-line

  return (
    <div className='p-10 bg-cover bg-center bg-no-repeat ' style={{ backgroundImage: "url('/homepagebg.jpg')" }}>
      <div className='bg-black bg-opacity-50 rounded-xl p-10 max-w-[400px] min-w-[200px]'>
        <form className="mx-auto">
          <div className='my-5'>
            <label className="text-left block uppercase font-bold my-5 mb-1 text-white flex">Pick-up Location
              {loading && (
                <div className="ml-2 inset-y-0 right-2 flex items-center pointer-events-none">
                  <svg
                    className="animate-spin h-4 w-4 text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                    ></path>
                  </svg>
                </div>
              )}
            </label>
            <select
              id="pickup-location"
              value={searchData.pickup}
              onChange={(e) => changeSearchData('pickup', e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              {branches
                .filter((branch) => branch.status === 'available')
                .map((branch) => (
                  <option key={branch.id} value={branch.id}>
                    {branch.name}
                  </option>
                ))}
            </select>
          </div>

          <div className='my-5'>
            <label className="text-left block uppercase font-bold my-5 mb-1 text-white">Return Location</label>

            <select
              id="dropoff-location"
              value={searchData.dropoff}
              onChange={(e) => changeSearchData('dropoff', e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="same_as_pickup">Same as pick up</option>
              {branches
                .filter((branch) => branch.status === 'available')
                .map((branch) => (
                  <option key={branch.id} value={branch.id}>
                    {branch.name}
                  </option>
                ))}
            </select>
          </div>

          <div className='my-5'>
            <label className="text-left block uppercase font-bold my-5 mb-1 text-white">Pick-up Date & Time</label>
            <button type="button" onClick={selectDateEvent} className=" w-full text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700">
              {searchData.startDate ? searchData.startDate + ' ' + searchData.startTime + ' - ' + searchData.endDate + ' ' + searchData.endTime : 'Select the time'}
            </button>
          </div>

          <div className='my-5'>
            <label className="text-left block uppercase font-bold my-5 mb-1 text-white">Age</label>

            <select
              id="driver-age"
              value={searchData.driverage}
              onChange={(e) => changeSearchData('driverage', e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="25">25+</option>
              <option value="21-25">21-25</option>
              <option value="65">65+</option>
            </select>

          </div>

          {popSelectDate &&
            <div
              tabIndex="-1"
              className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-1 flex justify-center items-center w-full h-full bg-black/50"
            >
              <div className="relative p-4 w-full max-w-[60%] min-w-[380px] max-h-full">
                <div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-800">
                  <div className="flex items-center justify-between p-4 border-b rounded-t dark:border-gray-700 border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                      Select Date & Time
                    </h3>
                    <button onClick={selectDateEvent} type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" >
                      <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                      </svg>
                      <span className="sr-only">Close modal</span>
                    </button>
                  </div>
                  <div className="pt-0 flex md:flex-row flex-col ">
                    <div className='mx-4 mb-4 flex-1'>
                      <label className="text-left uppercase font-bold text-sm text-gray-900 dark:text-white my-4 block">
                        Select the date
                      </label>
                      <DatePicker2 getDate={getDate} searchData={searchData} />
                    </div>
                    <div className='mx-4 flex-1'>
                      <label className="text-left uppercase font-bold text-sm text-gray-900 dark:text-white my-4 block">
                        Pick up time
                      </label>
                      <select id="startTime" value={searchData.startTime} onChange={(val) => changeSearchData('startTime', val.target.value)} className="my-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        {timeOptions.map((slot) => (
                          <option key={slot.key + 'start'} value={slot.key}>
                            {slot.title}
                          </option>
                        ))}
                      </select>

                      <label className="text-left uppercase font-bold text-sm text-gray-900 dark:text-white my-4 block">
                        drop off time
                      </label>
                      <select id="endTime" value={searchData.endTime} onChange={(val) => changeSearchData('endTime', val.target.value)} className="my-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        {timeOptions.map((slot) => (
                          <option key={slot.key + 'end'} value={slot.key}>
                            {slot.title}
                          </option>
                        ))}

                      </select>
                      <div className="grid grid-cols-2 gap-2 my-5">
                        <div></div>
                        <button
                          type="button"
                          onClick={() => selectDateEvent('check')}
                          className=" text-white bg-primary hover:bg-primary/80 focus:ring-4 focus:ring-primary/50 font-medium rounded-lg text-sm px-5 py-2.5 mb-2">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </form>

        <button
          type="button"
          ref={containerRef}
          onClick={findVehicle}
          className="text-white font-lg bg-primary hover:bg-primary/80 focus:ring-4 focus:ring-primary/50 rounded-lg px-5 py-2.5 mt-6">
          <VariableProximity
            label={'Find a Vehicle!'}
            className={'variable-proximity-demo'}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff='linear'
          />
        </button>
      </div >

      <AlertWindow setOpenAlert={setOpenAlert} openAlert={openAlert} message={alertMessage} />
    </div >
  );
}

export default Home;